import React from 'react';
import { Card } from './ui/card';
import * as LucideIcons from 'lucide-react';
import { services } from '../mockData';

const DesignDevelopment = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-br from-white via-emerald-50/20 to-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-200/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-purple-200/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Illustration */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/6032597/pexels-photo-6032597.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Design and Development"
                className="w-full h-auto rounded-2xl shadow-xl"
              />
              <div className="absolute -top-4 -left-4 w-full h-full border-4 border-emerald-500/20 rounded-2xl -z-10"></div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8 order-1 lg:order-2">
            <div>
              <div className="inline-block">
                <div className="h-1 w-16 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full mb-4"></div>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Design & Development
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                We understand the intricacies of software development inside-out. That's why we can provide a wide range of services, from discovery phase and UX research, to building rock-solid Mobile and Web applications enriched with user-centered visual experiences.
              </p>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {services.development.map((service) => {
                const Icon = LucideIcons[service.icon];
                return (
                  <Card
                    key={service.id}
                    className="p-4 hover:shadow-lg transition-all duration-300 border-l-4 border-l-emerald-500 hover:border-l-emerald-600 hover:scale-105 cursor-pointer group bg-white"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="p-2 bg-emerald-100 rounded-lg group-hover:bg-emerald-500 transition-colors">
                        <Icon className="w-5 h-5 text-emerald-600 group-hover:text-white transition-colors" />
                      </div>
                      <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                        {service.name}
                      </span>
                    </div>
                  </Card>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesignDevelopment;
